import { IconName } from 'src/app/components/icon/icons/icon-map';
import { IndicatorGroup } from 'src/app/model/configuration-service.models';
import { FlattenedIndicator, RelationshipLevel } from './wallet-alert-report.models';

export const ALL_INDICATORS_OPTION: FlattenedIndicator = {
  id: null,
  name: 'Todos',
  isParentIndicator: false,
  indicatorIds: [],
};

export const LOADING_INDICATORS_OPTION: FlattenedIndicator = {
  id: null,
  name: $localize`:@@loadingIndicators:Carregando indicadores...`,
  isParentIndicator: false,
  indicatorIds: [],
};

export const NO_INDICATORS_OPTION: FlattenedIndicator = {
  id: null,
  name: $localize`:@@noIndicatorsAvailable:No hay atributos disponibles`,
  isParentIndicator: false,
  indicatorIds: [],
};

export const VIRTUAL_L1_PARENT_NAME = $localize`:@@walletAlertVirtualGroupSocios:Socios`;
export const VIRTUAL_L2_PARENT_NAME = $localize`:@@walletAlertVirtualGroupOutrasParticipacoes:Otras participaciones`;

export const DEFAULT_LAST_PROCESSING_DATE = '- - / - - / - - - -';
export const DEFAULT_PER_PAGE = 10;
export const UNAVAILABLE_DATE = $localize`:@@js_unavailable:indisponible`;

export const INDICATOR_GROUP_LABEL_OVERRIDES: Record<string, string> = {
  '6003d919-6711-44c7-98c4-a521127f6cc8': 'Percentual',
};

export function resolveIndicatorLabel(
  indicatorId: string | undefined,
  indicatorGroup: string,
): string {
  return (indicatorId && INDICATOR_GROUP_LABEL_OVERRIDES[indicatorId]) ?? indicatorGroup;
}

export function getRelationshipLevelSuffix(level?: RelationshipLevel): string {
  if (level === RelationshipLevel.L1) return $localize`:@@partnersSuffix: (Socios)`;
  if (level === RelationshipLevel.L2) return $localize`:@@otherPartnersSuffix: (Otras part.)`;
  return '';
}

export const REGISTRATION_FIELD_LABEL_MAP: Record<string, string> = {
  consumerName: $localize`:@@regField_consumerName:nome`,
  federalStatusDescription: $localize`:@@regField_federalStatusDescription:situação do CPF`,
  birthDate: $localize`:@@regField_birthDate:data de nascimento`,
  zodiacSign: $localize`:@@regField_zodiacSign:signo`,
  educationLevelDescription: $localize`:@@regField_educationLevelDescription:grau de instrução`,
  consumerInformedDescription: $localize`:@@regField_consumerInformedDescription:sexo`,
  numberOfDependents: $localize`:@@regField_numberOfDependents:quantidade de dependentes`,
  maritalStatusDescription: $localize`:@@regField_maritalStatusDescription:estado civil`,
  additionalIDocumentType: $localize`:@@regField_additionalIDocumentType:título de eleitor`,
  phoneIndex: $localize`:@@regField_phoneIndex:index do telefone`,
  directDistanceDialing: $localize`:@@regField_directDistanceDialing:DDD (discagem direta à distância)`,
  phoneNumber: $localize`:@@regField_phoneNumber:número do telefone`,
  tradeName: $localize`:@@regField_tradeName:nome fantasia`,
  companyName: $localize`:@@regField_companyName:razão social`,
  legalNatureDescription: $localize`:@@regField_legalNatureDescription:natureza jurídica`,
  lineOfBusinessDescription: $localize`:@@regField_lineOfBusinessDescription:CNAE principal`,
  sintegraStatusDescription: $localize`:@@regField_sintegraStatusDescription:situação cadastral`,
  typeStreet: $localize`:@@regField_typeStreet:tipo de logradouro`,
  streetName: $localize`:@@regField_streetName:logradouro`,
  addressNumber: $localize`:@@regField_addressNumber:número`,
  complementAddress: $localize`:@@regField_complementAddress:complemento do logradouro`,
  neighborhood: $localize`:@@regField_neighborhood:bairro`,
  cityName: $localize`:@@regField_cityName:cidade`,
  state: $localize`:@@regField_state:UF`,
  zipCode: $localize`:@@regField_zipCode:CEP`,
};

export function parsePartnerRegistrationChangedFields(currentValue: string): string {
  try {
    const parsed: Record<string, boolean | null> = JSON.parse(currentValue);
    const labels = Object.entries(parsed)
      .filter(([, value]) => value === true)
      .map(([key]) => REGISTRATION_FIELD_LABEL_MAP[key] ?? key);

    if (labels.length === 0) return '';

    const joined = labels.join(', ') + '.';
    return joined.charAt(0).toUpperCase() + joined.slice(1);
  } catch {
    return '';
  }
}

export function parseShareholdingPartnerCount(currentValue: string): number {
  try {
    const parsed: { partnerId: string }[] = JSON.parse(currentValue);
    const uniqueIds = new Set(parsed.map((p) => p.partnerId));
    return uniqueIds.size;
  } catch {
    return 0;
  }
}

type IndicatorValues = `${IndicatorGroup}`;
type IndicatorKeysLowercase = Lowercase<IndicatorValues>;

export const INDICATOR_ICON_MAP: Partial<Record<IndicatorKeysLowercase, IconName>> = {
  negativações: 'no_dolar_sign',
  protestos: 'clipboard_exclamation_outlined',
  'ações cíveis': 'scale_balance',
  falências: 'bankruptcy',
  score: 'gauge_outlined',
  consultas: 'file_search_outlined',
  'dados cadastrais': 'id_card_outlined',
  'percentual do quadro societário': 'partners',
  'cheques sem fundos': 'file_dolar_outlined',
};

export const ALERT_TABLE_TITLES = {
  document: $localize`:@@js_document:Documento`,
  name: $localize`:@@js_name:Nombre`,
  alertDate: $localize`:@@alertDate:Fecha de alerta`,
  updatedAttribute: $localize`:@@updatedAttribute:Atributo cambiado`,
  previousValue: $localize`:@@previousValue:Valor anterior`,
  currentValue: $localize`:@@currentValue:Valor actual`,
  variation: $localize`:@@percentVariation:Variación (%)`,
};
